module.exports = new __parcel__URL__("blupax_logo.3c1b30da.png").toString();